export default "__VITE_ASSET__CCAOmO$D__"